<template>
  <div class="w-100">
    <s-crud
      @returnObject="refresh($event)"
      no-border
      title="Sustancias"
      :config="config"
      @save="save($event)"
      @clearForm="clearForm()"
      @addEvent="clearForm()"
      @activePrd="clearForm()"
      @rowSelected="rowSelected($event)"
      add
      edit
      remove
      restore
      :filter="filter"
      height="450"
    >
      <template v-slot="props">
        <v-container v-if="props.item != null" class="pb-0 mt-3">
          <v-row dense align="center">
            <v-col cols="12" md="4" lg="4" class="s-col-form">
              <s-select-definition
                label="Tipo de Sustancia *"
                :def="1740"
                v-model="props.item.TypeSubstances"
                :rules="[(v) => !!v || 'Tipo de Sustancia es obligatorio']"
                clearable
              />
            </v-col>
            <v-col cols="12" :md="$fun.isAdmin() ? 5 : 8" :lg="$fun.isAdmin() ? 5 : 8" class="s-col-form">
              <s-text
                ref="Description"
                label="Descripción *"
                v-model="props.item.Description"
                :rules="[(v) => !!v || 'Descripción es obligatoria']"
              />
            </v-col>
            <v-col v-if="$fun.isAdmin()" cols="12" md="3" lg="3" class="s-col-form">
              <v-switch
                v-model="props.item.IsQualityActive"
                :true-value="1"
                :false-value="0"
                label="Activo Calidad"
                color="primary"
                hide-details
                dense
                class="mt-0"
                @click.native.stop
                @change.native.stop
              />
            </v-col>
          </v-row>
        </v-container>
      </template>

      <template v-slot:filter>
        <v-container fluid class="py-1 px-3">
          <v-row dense align="center">
            <v-col cols="12" sm="6" md="4" lg="3">
              <s-select-definition
                label="Tipo de Sustancia"
                :def="1740"
                v-model="filter.TypeSubstances"
                clearable
              />
            </v-col>
            <v-col cols="12" sm="6" md="3" lg="2">
              <s-select
                label="Activo Calidad"
                v-model="filter.IsQualityActive"
                :items="[
                  { text: 'TODOS', value: null },
                  { text: 'SÍ', value: 1 },
                  { text: 'NO', value: 0 }
                ]"
                clearable
              />
            </v-col>
          </v-row>
        </v-container>
      </template>

      <template v-slot:IsQualityActive="{ row }">
        <v-chip
          x-small
          :color="row.IsQualityActive == 1 ? 'teal' : 'grey lighten-1'"
          dark
          style="margin: 0px"
        >
          {{ row.IsQualityActive == 1 ? "SÍ" : "NO" }}
        </v-chip>
      </template>

      <template v-slot:SecStatus="{ row }">
        <v-chip
          x-small
          :color="row.SecStatus == 1 ? 'success' : 'error'"
          dark
          style="margin: 0px"
        >
          {{ row.SecStatus == 1 ? "Activo" : "Inactivo" }}
        </v-chip>
      </template>
    </s-crud>
  </div>
</template>

<script>
import _sSubstancesService from "@/services/Technicalassistance/SubstancesService.js";

export default {
  data: () => ({
    selected: [],
    filter: {
      TypeSubstances: null,
      IsQualityActive: null,
    },
    config: {
      title: "Sustancias",
      service: _sSubstancesService,
      model: {
        AsuID: "ID",
        TypeSubstances: "int",
        TypeSubstancesName: "string",
        Description: "string",
        IsQualityActive: "int",
        SecStatus: "status",
      },
      headers: [
        {
          text: "ID",
          value: "AsuID",
          width: "8%",
          align: "end",
          sortable: true,
        },
        {
          text: "Tipo de Sustancia",
          value: "TypeSubstancesName",
          width: "25%",
          sortable: true,
        },
        {
          text: "Descripción",
          value: "Description",
          width: "40%",
          sortable: true,
        },
        {
          text: "Activo Calidad",
          value: "IsQualityActive",
          width: "14%",
          align: "center",
          sortable: true,
        },
        {
          text: "Estado",
          value: "SecStatus",
          width: "13%",
          align: "center",
          sortable: true,
        },
      ],
    },
  }),
  methods: {
    refresh(item) {
      this.$emit("refresh", item);
    },
    rowSelected(items) {
      this.selected = items;
      this.$emit("rowSelected", items);
    },
    clearForm() {
      this.$nextTick(() => {
        if (this.$refs.Description && this.$refs.Description.focus) {
          this.$refs.Description.focus();
        }
      });
    },
    save(item) {
      if (!item.TypeSubstances) {
        this.$fun.alert("Por favor seleccione el tipo de sustancia", "warning");
        return;
      }
      if (!item.Description || !item.Description.trim()) {
        this.$fun.alert("Por favor ingrese la descripción de la sustancia", "warning");
        return;
      }

      if (!this.$fun.isAdmin()) {
        item.IsQualityActive = 0;
      } else {
        item.IsQualityActive = item.IsQualityActive === 1 || item.IsQualityActive === '1' ? 1 : 0;
      }

      item.Description = item.Description.trim();
      item.UsrCreateID = this.$fun.getUserID();
      item.UsrUpdateID = this.$fun.getUserID();
      item.save();
    },
  },
};
</script>
